(() => {
  const seen = new WeakSet();

  function enableVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    if (video.hasAttribute('data-tm-home-video')) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'auto');

    const play = () => {
      const promise = video.play();

      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {
          // Browser kann Autoplay trotzdem blockieren,
          // z.B. bei Energiesparmodus, Datensparmodus oder Nutzer-Settings.
        });
      }
    };

    if (!seen.has(video)) {
      seen.add(video);
      video.addEventListener('loadedmetadata', play, { once: true });
      video.addEventListener('canplay', play, { once: true });
    }

    play();
  }

  function enableIframe(iframe) {
    if (iframe.hasAttribute('data-tm-home-iframe')) return;
    const src = iframe.getAttribute('src');
    if (!src) return;

    let url;

    try {
      url = new URL(src, window.location.href);
    } catch (error) {
      return;
    }

    const host = url.hostname.replace(/^www\./, '');
    let changed = false;

    if (
      host.includes('youtube.com') ||
      host.includes('youtube-nocookie.com') ||
      host === 'youtu.be'
    ) {
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('mute', '1');
      url.searchParams.set('playsinline', '1');
      changed = true;
    }

    if (host.includes('vimeo.com')) {
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('muted', '1');
      url.searchParams.set('playsinline', '1');
      changed = true;
    }

    if (changed) {
      const allow = iframe.getAttribute('allow') || '';
      iframe.setAttribute(
        'allow',
        `${allow}; autoplay; encrypted-media; picture-in-picture`
      );

      if (iframe.src !== url.toString()) {
        iframe.src = url.toString();
      }
    }
  }

  function run(root = document) {
    root.querySelectorAll?.('video').forEach(enableVideo);

    root
      .querySelectorAll?.(
        'iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]'
      )
      .forEach(enableIframe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => {
    run(event.target);
  });

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.matches?.('video')) enableVideo(node);
        if (node.matches?.('iframe')) enableIframe(node);

        run(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
